import type { ActiveOrArchived } from '@common/enums/activeOrArchived';
import type { HolterRecorderItem } from '@common/interfaces/cardiology/holterRecorderItem';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/holterProcesses/';

export async function getHolterProcessesAndProcedures(
    status: ActiveOrArchived,
    pagination: { limit: number; page: number },
    signal: AbortSignal
): Promise<{ items: HolterRecorderItem[]; total: number } | undefined> {
    const url = `${baseUrl}?status=${status}&page=${pagination.page}&limit=${pagination.limit}`;

    const result = await fetchJson<{ items: HolterRecorderItem[]; total: number }>({ method: 'GET', signal, url });

    return result.json;
}
